import { GAIA_TIMEOUT_MS } from '../services/API';

export const getGaiaQuestion = async (api, dynamicFields, community, channelType, selectedInterestList, ask) => {
    const gaia_question = {
        student_details: {
            email: ask.email,
            community: community.name,
            subject: 'Quick Connect',
            first: ask.first,
            last: ask.last,
            channelType: channelType,
            interests: selectedInterestList,
            source: {
                origin: "Quick Connect",
                sourceID: `timestamp:${Date.now()}`,
                userID: "Web user"
            },
            dynamicFields: {
                ...dynamicFields,
                year: dynamicFields.year2 || dynamicFields.year,
                disclaimer: false
            }
        },
        message_prompt: {
            text: [ask.bio, ask.text, ask.closeNicely]
                .reduce((acc, curr) => curr ? acc + (acc ? '\n' : '') + curr : acc, '')
        }
    };

    // Add majors information to the prompt (same logic as chatbot)
    if (dynamicFields.major && Array.isArray(dynamicFields.major) && dynamicFields.major.length > 0) {
        const majorInfo = dynamicFields.major.join(', ');
        const additionalContext = `\n\nAdditional context: I am studying ${majorInfo}.`;
        gaia_question.message_prompt.text += additionalContext;
    } else {
        console.log("=== MAJOR INFO NOT ADDED TO WEB FORM ===");
    }

    try {
        const response = await api.post('asks/gaia_question', {
            gaia_question
        }, { timeout: GAIA_TIMEOUT_MS });
        return response.data.email_message; // Return the answer
    } catch (err) {
        console.error('Gaia request failed, returning fallback message:', err);
        return [ask.bio, ask.text, ask.closeNicely]
                .reduce((acc, curr) => curr ? acc + (acc ? '\n' : '') + curr : acc, '');
    }
};


export const saveGaiaAnswer = (gaiaAnswer) => {
    gaiaAnswer = gaiaAnswer.replace(/\n/g, '<br>');
    return gaiaAnswer;
};



// WEBPACK FOOTER //
// ./src/helpers/getGaiaQuestion.js